module.exports = __webpack_public_path__ + "static/media/Training.b8cf9bfa.png";